// for tabs change
function ShowErrors(elm, show) {
  // show (true) will show error else will empty errors elm
  if(show) {
    if(!elm.childElementCount) {
      const newElm = document.createElement('ul')
      newElm.textContent = 'Please select options'
      elm.appendChild(newElm)
    }
  } else {
    console.log(elm)
    elm.innerHTML = ''
  }
}

function removeErrorFields(el) {
  el.innerHTML = ''
}

function clearCustomSelectedFields(btns) {
  btns.forEach(btn => {
    const imgExist = btn.querySelector('img')
    const btnText= btn.querySelector('.select-text') 
    if(imgExist) {
      imgExist.remove()
    }
    btnText.textContent = 'Select'
  })
}
function clearAllRadioFields(allRadioFields) {
  allRadioFields.forEach(inp => {
    inp.checked = false;
  })
}
function clearAllTextFields(allTextFields) {
  allTextFields.forEach(inp => {
    inp.value =''
  })
}
function removeTrailingZeros(value) {
  return value.split('.')[0];
}

function convertInchCm(parameter) {
  const sizeChartImages = document.querySelectorAll("[js-size-chart-image]")
  sizeChartImages.forEach( image => {
    if (image.getAttribute("data-parameter") === parameter) {
      image.classList.remove("visually-hide")
    }else {
      image.classList.add("visually-hide");
    }
  })
}

function requiredFieldsToggle(elementsList, remove ) {
  if(remove) {
    elementsList.forEach(elm => {
      elm.removeAttribute('required')
      elm.setAttribute('disabled', true)
    })
  } else {
    elementsList.forEach(elm => {
      elm.setAttribute('required', true)
      elm.removeAttribute('disabled')
    })
  }
}

function disableHiddenRequiredFields(form) {
  const root = form || document;
  root.querySelectorAll('.hide [required], .hidden [required], [hidden] [required]').forEach(function (elm) {
    elm.removeAttribute('required');
    elm.setAttribute('disabled', 'true');
  });
}

function getPdpDenominationFieldset(form) {
  const root = form || document;
  return root.querySelector('fieldset.o-Denominations, fieldset.o-Denomination, fieldset[js-denomination-options]');
}

function isPdpDenominationMissing(form) {
  const fieldset = getPdpDenominationFieldset(form);
  if (!fieldset) return false;
  const checked = fieldset.querySelector('.product-form__input_wrap input[type="radio"]:checked, input[type="radio"]:checked');
  return !checked || !String(checked.value || '').trim();
}

function syncPdpDenominationError(form) {
  const root = form || document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  const missing = isPdpDenominationMissing(root);
  if (missing) appendPdpRequiredOptionError(root, 'Denomination');
  else clearPdpRequiredOptionError(root, 'Denomination');
  return missing;
}

function blockIfPdpDenominationMissing(form) {
  if (!isPdpDenominationMissing(form)) return false;
  syncPdpDenominationError(form);
  const fieldset = getPdpDenominationFieldset(form);
  const target = fieldset || (form && form.querySelector('[js-pdp-form-error]')) || form;
  if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return true;
}

function isPdpSizeMissing(form) {
  const root = form || document;
  const fieldset = root.querySelector('fieldset.o-Size, fieldset[js-size-options]');
  if (!fieldset) return false;
  if (root.querySelector('.o-Stitched [value="Unstitched"]:checked, .o-Stitched [value="Made to Order"]:checked')) return false;

  const trigger = fieldset.querySelector('[js-pdp-mobile-size]');
  const triggerVisible = trigger && window.getComputedStyle(trigger).display !== 'none';
  if (triggerVisible) {
    const label = (trigger.textContent || '').trim();
    return !label || label.toLowerCase() === 'select size';
  }

  const checked = fieldset.querySelector('.product-form__input_wrap input[type="radio"]:checked');
  if (!checked || !checked.value || checked.value === 'Fabric Only') return true;
  const lab = checked.closest('.product-form__input_wrap') && checked.closest('.product-form__input_wrap').querySelector('label');
  if (lab && (lab.classList.contains('hide') || lab.classList.contains('default-variant-hide'))) return true;
  return false;
}

function syncPdpSizeError(form) {
  const root = form || document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  const missing = isPdpSizeMissing(root);
  if (missing) appendPdpRequiredOptionError(root, 'size');
  else clearPdpRequiredOptionError(root, 'size');
  const inline = root && root.querySelector('[js-pdp-mobile-size-error]');
  if (inline) inline.hidden = !missing;
  return missing;
}

function isPdpBlouseStyleMissing(form) {
  const root = form || document;
  const requiredInput = root.querySelector('#blouse-style-input');
  if (!requiredInput) return false;
  const wrap = requiredInput.closest('.options-dropdown-list');
  if (wrap && (wrap.classList.contains('hide') || wrap.classList.contains('hidden'))) return false;
  if (requiredInput.disabled) return false;
  if (!requiredInput.hasAttribute('required') && !requiredInput.hasAttribute('js-required-property-field')) return false;
  return String(requiredInput.value || '').trim() === '';
}

function appendPdpRequiredOptionError(form, optionName) {
  if (optionName === 'size' && form) {
    const inlineSizeError = form.querySelector('[js-pdp-mobile-size-error]');
    if (inlineSizeError && window.matchMedia('(max-width: 749.98px)').matches) {
      inlineSizeError.hidden = false;
      return;
    }
  }
  const errorWrapper = form && form.querySelector('[js-pdp-form-error] ul');
  if (!errorWrapper) return;
  const existing = errorWrapper.querySelector(`li[data-option-name="${optionName}"]`);
  if (!existing) {
    const newError = document.createElement('li');
    newError.setAttribute('data-option-name', optionName);
    newError.textContent = `Please select ${optionName}`;
    errorWrapper.appendChild(newError);
  }
  errorWrapper.style.display = 'block';
}

function clearPdpRequiredOptionError(form, optionName) {
  const errorWrapper = form && form.querySelector('[js-pdp-form-error] ul');
  if (!errorWrapper) return;
  const existing = errorWrapper.querySelector(`li[data-option-name="${optionName}"]`);
  if (existing) existing.remove();
  if (!errorWrapper.childElementCount) errorWrapper.style.display = 'none';
}

document.addEventListener('submit', function (event) {
  if (event.target && event.target.matches && event.target.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) {
    disableHiddenRequiredFields(event.target);
  }
}, true);

document.addEventListener('change', function (event) {
  const input = event.target;
  if (!input || input.type !== 'radio') return;
  if (!input.closest('fieldset.o-Denominations, fieldset.o-Denomination, fieldset[js-denomination-options]')) return;
  syncPdpDenominationError(input.form || input.closest('form'));
});

function toggleModal(element, show, container, containerTarget, target, modalName) {
  if(show == 'show') {
    element.classList.remove('hide')
  } else if(show == 'close') {
    let selectedOption = element.querySelector('input:checked');
    if(selectedOption){
      selectedOption.checked = false
    }
    element.classList.add('hide')

    // reset button value in case of close cross btn
    const btnElm = document.querySelector(`[js-khadi-open-popup-modal][data-modal="${modalName}"] span`)
    if(modalName != 'size-chart') {
      btnElm.textContent = 'Please Select'
    }
  } else if(show == 'save') {
    let selectedOption = element.querySelector('input:checked');

    element.classList.add('hide')
    // container.querySelector(containerTarget).textContent = selectedOption.value
    // change target button's value on in save case
    const btnElm = document.querySelector(`[js-khadi-open-popup-modal][data-modal="${modalName}"] span`)
    console.log({btnElm})
    btnElm.textContent = selectedOption.value
  }
}

function unselectOptionDrops(container, listContainer) {
  listContainer?.querySelectorAll('.select-styled').forEach(el => {
    el.firstChild.textContent = 'Please Select'
  })
  listContainer?.querySelectorAll('[js-option-drop-1] .select-options').forEach(el=> {
    el.querySelectorAll('li').forEach((elm, index) => {
      if(index == 0) {
        elm.classList.add('is-selected')
      } else {
        elm.classList.remove('is-selected')
      }

    })
  })
  listContainer?.querySelectorAll('[js-custom-option-select]').forEach(el => {
    el.selectedIndex = 0
  })

  // blouse case
  if(container.querySelector('[js-blouse-style-popup] input:checked')) {
    listContainer.querySelector('.option-drop[js-khadi-open-popup-modal] span').firstChild.textContent = 'Please Select'
    container.querySelector('[js-blouse-style-popup] input:checked').checked = false
  }
}


function clearWhatsAppEntries() {
 
  const container = document.querySelector('[js-pdp-whatsapp-measurement-popup]')
  const phoneNumber = container?.querySelector('input[type="number"]')
  const radioCheck = container?.querySelector('input[type="radio"]:checked')

  let selectBox = container?.querySelector('select#country_code');
  if(selectBox) {
    selectBox.removeAttribute('name', 'items[0][properties][Country Code]');
    selectBox.setAttribute("disabled", "disabled");
  }
  
  if(phoneNumber) {
    phoneNumber.value  = ''
  }
  if(radioCheck) {
    radioCheck.checked = false
  }

  
}

function clearAfterOrderEntries() {
  // items[0][properties][Measure After Order]
  const inputfield = document.querySelector('[js-pdp-custom-measurement-complete-modal] input:checked')
  if(inputfield) {
    inputfield.checked = false
  }

}

function clearCustomMeasurementEntries() {
  // Clear All Input fields inside custom measurements
  const allCustomOptions =document.querySelectorAll('[data-popup-modal-option-name] input:checked')

  if(allCustomOptions.length) {
    allCustomOptions.forEach(el_ => {
      el_.checked = false
    })
  }

  // reset all custom measurement select buttons
  const allButtons = document.querySelectorAll('[js-pdp-custom-measurement-popup] [js-pdp-select-detail-btn]')
  if(allButtons.length) {
    allButtons.forEach(el_ => {
      const text_ = el_.querySelector('.select-text')
      const img_  = el_.querySelector('img')
      if(text_) {
        text_.textContent = 'Select'
      }
      if(img_) img_.remove()
    })
  }
}

function ToggleUpsellReturnNote(templateContainer) {
  if(templateContainer?.querySelector('[js-stitch-return-note]')) {
    templateContainer?.querySelector('[js-stitch-return-note]').classList.add('hide')
  }
}
function ToggleReturnNote(templateContainer) {
  if(templateContainer?.querySelector('[js-stitch-return-note]')) {
    templateContainer?.querySelector('[js-stitch-return-note]').classList.remove('hide')
  }
  // show stitch return note
  const stitchUpsell = templateContainer.querySelector('[js-stitch-upsell-wrap]')
  const upsellSelected = stitchUpsell?.querySelector('[upsell-product] #stitched-blouse:checked')
  if(upsellSelected) {
    stitchUpsell?.querySelector('[js-stitch-return-note]')?.classList.remove('hide')
  }
}